"use client";

import QRCodeStyling from "qr-code-styling";
import { useEffect, useRef, useState } from "react";
import styles from "./styles.module.scss";

const CustomQrCode = ({ code }: { code?: string }) => {
  const ref = useRef<any>(null);
  const [qrCode, setQrCode] = useState<any>(null);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const qrInstance = new QRCodeStyling({
        width: 85,
        height: 85,
        type: "canvas",
        data: code || "",
        image: "",
        dotsOptions: {
          color: "#4F7770",
          type: "rounded",
        },
        cornersSquareOptions: {
          color: "#4F7770",
          type: "extra-rounded",
        },
        cornersDotOptions: {
          color: "#4F7770",
          type: "dot",
        },
        backgroundOptions: {
          color: "transparent",
        },
        qrOptions: {
          errorCorrectionLevel: "H",
        },
      });

      setQrCode(qrInstance);
    }
  }, []);

  useEffect(() => {
    if (qrCode && ref.current) {
      qrCode.append(ref.current);
    }
  }, [qrCode]);

  useEffect(() => {
    if (qrCode) {
      qrCode.update({
        data: code,
      });
    }
  }, [code, qrCode]);

  return (
    <div className={styles.qrCodeContainer}>
      <div className={styles.qrCode}>
        <div ref={ref} />
      </div>
    </div>
  );
};

export default CustomQrCode;
